import {getStore} from '@/utils/store'
/*
* Vuex store 实例的根 state 对象
*/
const user = {
  state: {
    tyrzUploadPortraitHeaders: getStore({name: 'tyrzUploadPortraitHeaders', type: 'session'}) // 图片上传请求头信息
  },
  mutations: {
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js